import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import { useCountdownTimer } from '~/hooks/useCountdownTimer';
import adyenService from '~/services/Adyen';

import { checkoutStore, mainStore } from '~/stores';

import styles from './AdyenTimer.module.scss';

export const AdyenTimer = observer(() => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const cancellationDelay = checkoutStore.cancellationDelay;
  const isThreeds2Active = checkoutStore.isThreeds2Active;
  const timerDuration = cancellationDelay ? cancellationDelay - 15000 : 0;

  const { timeLeft, isExpired } = useCountdownTimer({
    totalTimeMs: timerDuration,
    shouldReset: !isThreeds2Active,
    onTimeExpired: () => {
      mainStore.pushAlert('error', t('errors:paymentFailed'));

      checkoutStore.setIsThreeds2Active(false);
      checkoutStore.setCancellationDelay(null);

      adyenService.initPayment();
    },
  });

  useEffect(() => {
    if (isThreeds2Active && cancellationDelay && timerDuration > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [isThreeds2Active, cancellationDelay, timerDuration]);

  useEffect(() => {
    if (!isThreeds2Active) {
      setIsVisible(false);
    }
  }, [isThreeds2Active]);

  const formatTime = (minutes: number, seconds: number) => {
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  };

  if (!isVisible || isExpired || timerDuration <= 0) {
    return null;
  }

  return (
    <div className={styles.timer}>
      <div className={styles.timerContent}>
        <Icon type="time" className={styles.icon} size={24} />
        <div className={styles.timerText}>
          <span className={styles.label}>
            {t('phrases:timeLeftToComplete')}:
          </span>
          <span className={styles.time}>
            {formatTime(timeLeft.minutes, timeLeft.seconds)}
          </span>
        </div>
      </div>
    </div>
  );
});
